export default {
  title: "Il s'agit d'un SAFE Tag!",
  subtitle: {
    isNotSosafeUser:
      'Téléchargez notre application pour scanner votre SAFE Tag et commencez à être protégé par SOSAFE',
  },
  downloadApp: 'Télécharger SOSAFE',
};
